import { reactive, readonly } from "vue";
import { useCookies, globalCookiesConfig  } from "vue3-cookies";
import axios from "axios";

import * as dayjs from 'dayjs';
import MinMax from 'dayjs/plugin/minMax';
dayjs.extend(MinMax)

import utils from "@/global";

globalCookiesConfig({
    expireTimes: 0,
    path: "",
    domain: "",
    secure: true,
    sameSite: "Strict"
});

const { cookies } = useCookies();

const common = {
    setId: function (asset, id) {
        asset.id = id;
    },
    setList: function (asset, list) {
        asset.list = list;
    },
    getListItem: function (asset, id=null, index) {
        
        if (index === 'dateFirst') {
            return this.sortedList(asset, true);
        } else if (index === 'dateLast') {
            return this.sortedList(asset, false);
        }
                
        if (!id) {
            id = asset.id;
        }
        
        if (id) {
            const list = asset.list.filter( function (item){
                return parseInt(item.id) === parseInt(id);
            });  
            
            if (list.length > 0) {
                return list[0];
            }
        }
        return null;
    },
    sortedList: function (asset, asc=false) {
        if ( !(asset.list.length > 0) ) {
            return null;
        }
                    
        return asset.list.reduce( function (a, b) {
            const cmp = dayjs(a.datetime) > dayjs(b.datetime);
            
            if (asc == true) {
                return !cmp ? a : b;
            } else {
                return cmp ? a : b;
            }

        })
    }
}

const state_data = {
    user: {
        loggedIn: false,
		token: null
    },
    profile: {
        year: null,
        area: null,
        id: null,
        list: [],
        item: function (id=null) {
            return common.getListItem(this, id, null); 
        }
    },
    waterPoint: {
        id: null,
        list: [],
        item: function (id=null) {
            return common.getListItem(this, id, null);
        }
    },
    withdrawal: {
        id: null,
        list: [],
        item: function (id=null, recent=null) {
            return common.getListItem(this, id, recent);
        }
    },
    level: {
        id: null,
        list: [],
        item: function (id=null, recent=null) {
            return common.getListItem(this, id, recent);
        }
    }
}

const state = reactive(utils.deepClone(state_data));

const actions = {
    logIn: function (token, expireTimes) {
		actions.resetState();	
        // cookies.set('token', token, expireTimes, null, 'alb-bayern.de');
        state.user.loggedIn = true;
		state.user.token = token;
    },
    resetState: function () {
		Object.assign(state, utils.deepClone(state_data));
		console.log(state_data);
    },
    logOut: function () {
		actions.resetState();
        cookies.remove('token', null, 'alb-bayern.de');
        state.user.loggedIn = false;
		state.user.token = null;
    },
    checkLogIn: function () {    
        if (cookies.get('token') === null) {
            actions.logOut();
        } else {
            state.user.loggedIn = true;
			state.user.token = cookies.get('token');
        }
    },
    _setProfileId: function (profileId) {
        state.profile.profileId = profileId;
    },
    _getProfileId: function () {
        return state.profile.profileId;
    },
    _isProfileSelected: function () {
        return !(state.profile.profileId === null);
    },
    _getProfile: function (profileId = null) {
        
        if (!profileId) {
            profileId = state.profile.profileId;
        }
        
        if (profileId) {
            const profiles = state.profile.list.filter( function (profile){
                return profile.id === profileId;
            });  
            
            if (profiles.length > 0) {
                return profiles[0];
            }
        }
        
        return {};
    },
    profile: {
        setYear: function (year) {
           state.profile.year = year;
        },
        _get: function (profileId = null) {
            
            return state.profile.item(profileId);
            
            /*
            
            if (!profileId) {
                profileId = state.profile.profileId;
            }
            
            if (profileId) {
                const profiles = state.profile.list.filter( function (profile){
                    return profile.id === profileId;
                });  
                
                if (profiles.length > 0) {
                    return profiles[0];
                }
            }
            
            return {};
            
            */
        },
        set: function (attrs, id = null) {
            
            if (!id) {
                id = state.profile.id;
            }
			
            state.profile.list.forEach( function (profile , index) {
                if (parseInt(profile.id) === parseInt(id)) {
                    state.profile.list[index] = Object.assign({}, state.profile.list[index], attrs);
                }
            })
            
        },
        setId: function (id) {
            state.profile.id = id;    
            //state.profile.profileId = id;
        },
        setList: function (list) {
            state.profile.list = list;
            //state.profile.profiles = list;
        }
    },
    waterPoint: {
        _setSelectedId: function (id) {
            state.waterPoint.id = id;
        },
        setId: function (id) {
            common.setId(state.waterPoint, id);
        },
        setList: function (list) {
            common.setList(state.waterPoint, list);  
        },
        get: function (waterPointId = null) {
        
            if (!waterPointId) {
                waterPointId = state.waterPoint.id;
            }
            
            if (waterPointId) {
                const waterPoints = state.waterPoint.list.filter( function (waterPoint){
                    return parseInt(waterPoint.id) === parseInt(waterPointId);
                });  
                
                if (waterPoints.length > 0) {
                    return waterPoints[0];
                }
            }
            return null;
        }
    },
    withdrawal: {
        setId: function (id) {
            common.setId(state.withdrawal, id);
        },
        setList: function (list) {
            common.setList(state.withdrawal, list);
        }
    },
    level: {
        setId: function (id) {
            common.setId(state.level, id);
        },
        setList: function (list) {
            common.setList(state.level, list);
        }
    }
}

axios.interceptors.request.use(function (request) {
    actions.checkLogIn();
    
    const token = cookies.get('token');
    request.headers['JWT-Authorization'] =  token ? `Bearer ${token}` : '';
    
    return request;
}, function (error) {
    // Do something with request error
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    actions.checkLogIn();

    if ( utils.getAssocValue(response, 'data.data.loggedIn') === false ) {
        actions.logOut();
    }

    if ( utils.getAssocValue(response, 'data.data.user.loggedIn') === false ) {
        actions.logOut();
    }
    
    response.alert = function (message) {
        alert(message);
    }
    
    response.standardErrorHandled = false;
    
    response.standardErrorHandler = function (errors) {
        if (response.standardErrorHandled === true) {
            return;
        }
        
        errors.forEach(function(item, index, arr) {
            if (item.message_user) {
                response.alert(item.message_user);
            } else if (item.type) {
                response.alert(item.type);
            } else {
                response.alert('Es ist ein Fehler in der Serverkommunikation aufgetreten. Sollte der Fehler weiter bestehen, wenden Sie sich bitte unter info@alb-bayern.de dirket an uns.');
            }
        });
        
        response.standardErrorHandled = true;
    }
    
    // eslint-disable-next-line no-unused-vars  
    response.handler = function (dataHandler, errorHandler) {
        
        let response = this;
        
        // Costum Error Handling    
        if ( response.data && response.data.errors && Array.isArray(response.data.errors) ) {
            if (errorHandler) {
                errorHandler(response.data.errors);
            } else {
                response.standardErrorHandler(response.data.errors);
            }
        // Data Handling  
        } else if ( response.data && response.data.data ) {
            if (dataHandler) {
                dataHandler(response.data.data);
            }
        }
    }
    
    return response;
  
}, function (error) {
    // Do something with respond error
    actions.checkLogIn();    
    
    alert('Es ist ein Fehler in der Serverkommunikation aufgetreten. Sollte der Fehler weiter bestehen, wenden Sie sich bitte unter info@alb-bayern.de dirket an uns.');
    
    if (error.response && error.response.data && error.response.data.errors) {
        console.log(JSON.stringify(error.response.data.errors));
    }
    
    throw error;
    //return Promise.reject(error);
    //return Promise.resolve();
});


//state.data = state;
state.actions = actions;
export default readonly(state);

/*
export default { 
    data: readonly(state), 
    actions
};


*/